import { Button, Checkbox, Form, Input } from "antd";
import { observer } from "mobx-react-lite";
import PriceInput from "../components/price-input";
import { BrandSelector } from "../components/brand-selector";
import PartTypeSelector from "../components/part-type-selector";
import { IBrand } from "@drone-parts.garphild.pro/interfaces";

/* eslint-disable-next-line */
export interface AddPartFormProps {
  brand: IBrand['_id'];
  name: string;
  description: string;
  partType: string[];
  selectBrand: (brandId: IBrand['_id']) => void;
  selectPartType: (partTypeId: string[]) => void;
  setName: (name: string) => void;
  setDescription: (description: string) => void;
  onSubmit: () => void;
  isAddMore: boolean;
  setIsAddMore: (isAddMore: boolean) => void;
  officialUrl: string;
  setOfficialUrl: (officialUrl: string) => void;
  officialPrice: number;
  setOfficialPrice: (officialPrice: number) => void;
  expired: boolean;
  setExpired: (expired: boolean) => void;
}

export function AddPartForm(
  {
    brand,
    name,
    description,
    partType,
    officialUrl,
    selectBrand,
    selectPartType,
    setName,
    setDescription,
    setOfficialUrl,
    onSubmit,
    isAddMore,
    setIsAddMore,
    officialPrice,
    setOfficialPrice,
    expired,
    setExpired,
  }: AddPartFormProps)
{
  return (
    <div>
      <Form>
        <BrandSelector brand={brand} selectBrand={selectBrand} />
        <PartTypeSelector
          partType={partType}
          onChange={selectPartType}
        />
        <Form.Item label="Name">
          <Input value={name} onChange={(e) => setName(e.target.value)} />
        </Form.Item>
        <Form.Item label="Description">
          <Input value={description} onChange={(e) => setDescription(e.target.value)} />
        </Form.Item>
        <Form.Item label="Official url">
          <Input value={officialUrl} onChange={(e) => setOfficialUrl(e.target.value)} />
        </Form.Item>
        <Form.Item label="Official price">
          <PriceInput price={officialPrice} onChange={setOfficialPrice} />
        </Form.Item>
        <Form.Item label="Expired">
          <Checkbox checked={expired} onChange={(e) => { setExpired(!expired)}} />
        </Form.Item>
        <Form.Item label="Add more">
          <Checkbox checked={isAddMore} onChange={(e) => { setIsAddMore(!isAddMore)}} />
        </Form.Item>
        <Button onClick={onSubmit}>Save</Button>
      </Form>
    </div>
  );
}

export default observer(AddPartForm);
